import React from "react";
import { useTranslation } from "react-i18next";
import { VelavuMenuFilterItem } from "../../../../../elements/velavu-menu-filter";
import * as styles from "./devices-filter.module.scss";

interface DevicesFilterProps {
	filterBattery: boolean | undefined;
	selectBattery: (filter: boolean | undefined) => void;

	filterStatus: boolean | undefined;
	selectStatus: (filter: boolean | undefined) => void;
}

export default function DevicesFilter(props: DevicesFilterProps) {
	const { t } = useTranslation();

	return (
		<div className={styles.container}>
			<div className={styles.column}>
				<div className={styles.title}>
					{t("dashboard.filters.status")}
				</div>
				<VelavuMenuFilterItem
					checked={props.filterStatus === undefined}
					onClick={() => props.selectStatus(undefined)}
				>
					{t("dashboard.filters.all")}
				</VelavuMenuFilterItem>
				<VelavuMenuFilterItem
					checked={props.filterStatus === true}
					onClick={() => props.selectStatus(true)}
				>
					{t("connection_status.active")}
				</VelavuMenuFilterItem>
				<VelavuMenuFilterItem
					checked={props.filterStatus === false}
					onClick={() => props.selectStatus(false)}
				>
					{t("connection_status.inactive")}
				</VelavuMenuFilterItem>
			</div>

			<div className={styles.column}>
				<div className={styles.title}>
					{t("dashboard.filters.battery_level")}
				</div>
				<VelavuMenuFilterItem
					checked={props.filterBattery === undefined}
					onClick={() => props.selectBattery(undefined)}
				>
					{t("dashboard.filters.all")}
				</VelavuMenuFilterItem>
				<VelavuMenuFilterItem
					checked={props.filterBattery === true}
					onClick={() => props.selectBattery(true)}
				>
					{t("dashboard.filters.low_battery")}
				</VelavuMenuFilterItem>
			</div>
		</div>
	);
}
